"use strict";

module.exports = function (value) {
    if (value && value.toString) {
        return value.toString();
    }
    return String(value);
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/sinon/lib/sinon/util/core/value-to-string.js
// module id = 66
// module chunks = 0